<div class="flex h-[100vh]" [ngClass]="{'admin-module-container': isSidebar && isNavbar}">
    <app-sidebar *ngIf="isSidebar"></app-sidebar>
    <div class="flex-1 h-[100vh] min-w-0">
        <app-navbar *ngIf="isNavbar"></app-navbar>
        <div
            [ngClass]="{
                'h-[calc(100%-60px)]': isSidebar && isNavbar,
                'min-h-[calc(100vh-60px)]': isHeader && isFooter
            }"
        >
            <app-header *ngIf="isHeader"></app-header>
            <div [ngClass]="{'px-4 pt-4 pb-4 h-full overflow-auto': isSidebar && isNavbar}">
                <router-outlet></router-outlet>
            </div>
        </div>
        <app-footer *ngIf="isFooter"></app-footer>
    </div>
</div>
<app-no-internet
    *ngIf="isOffline"
    (retry)="retryConnection()">
</app-no-internet>